import { FamilyInfo, SessionsPerCampers, SiblingDiscountChart } from '../../types/libertyLake'

export const checkIfMultiWeekDiscount = (sessionsPerCampers: SessionsPerCampers[]): boolean => {
  let sum = 0
  sessionsPerCampers.forEach(sessionPerCamper => {
    sum += sessionPerCamper.multiWeekDiscount
  })
  return sum > 0
}

export const checkIfPreSchoolDiscount = (sessionsPerCampers: SessionsPerCampers[]): boolean => {
  let preSchoolDiscount = false
  sessionsPerCampers.forEach(sessionPerCamper => {
    if (sessionPerCamper.grade === 'Pre thru K') {
      preSchoolDiscount = true
    }
  })
  return preSchoolDiscount
}

export const checkIfSiblingDiscount = (sessionsPerCampers: SessionsPerCampers[], discount?: Record<string, SiblingDiscountChart>) => {
  // Sibling discount only applies when there are 2+ campers
  if (sessionsPerCampers.length < 2) {
    return false
  }

  // Prefer deriving from the chart (used in Step2 calculations)
  for (let i = 1; i <= sessionsPerCampers.length; i++) {
    const percentage = discount?.[`${i}`]?.Percentage ?? 0
    if (percentage > 0) {
      return true
    }
  }

  // Fallback if percentages are stored per-camper
  return sessionsPerCampers.some(s => (s.siblingDiscountPercentage ?? 0) > 0)
}

export const checkIfTransportationDiscount = (familyInfo: FamilyInfo): boolean => {
  if (
    (familyInfo.amTransportationDiscount > 0 && familyInfo.amTransportationChoice.includes('$')) ||
    (familyInfo.pmTransportationDiscount > 0 && familyInfo.pmTransportationChoice.includes('$'))
  ) {
    return true
  } else {
    return false
  }
}

export const checkIfOccupationalDiscount = (familyInfo: FamilyInfo) => {
  if (familyInfo.occupation !== 'None') {
    return true
  } else {
    return false
  }
}

export const checkIfEarlyPayDiscount = (familyInfo: FamilyInfo) => {
  if (familyInfo.earlyPayDiscount > 0 && familyInfo.isEarlyPaying === true) {
    return true
  } else {
    return false
  }
}

export const checkIfNewFamilyDiscount = (familyInfo: FamilyInfo) => {
  if (familyInfo.isNewCampFamily === true && familyInfo.newFamilyDiscount > 0) {
    return true
  } else {
    return false
  }
}

export const formatNumberWithCommas = (number: number) => {
  if (typeof number !== 'number') {
    number = parseFloat(number)
  }

  if (isNaN(number)) {
    return 'Invalid input'
  }

  return number.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}
